import { render, staticRenderFns } from "./FichasArtistas.vue?vue&type=template&id=1fb874f8&scoped=true&"
import script from "./FichasArtistas.vue?vue&type=script&lang=js&"
export * from "./FichasArtistas.vue?vue&type=script&lang=js&"
import style0 from "./FichasArtistas.vue?vue&type=style&index=0&id=1fb874f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb874f8",
  null
  
)

export default component.exports